export const AddonCategory = (json: IAddonCategory): IAddonCategoryModel => {
	const { name, name_trans, sort_order, ...rest } = json

	const nameModel = LangContentToModel(name)

	return {
		name: nameModel,
		// `name_trans` jest zwracane tylko na pełnym zasobie, nie na liście — fallback na nazwę PL z `name`.
		nameTrans: name_trans ?? nameModel.pl,
		sortOrder: sort_order,
		...rest,
	}
}

export const AddonCategoryToCreatePayload = (model: IAddonCategoryForm): IAddonCategoryCreatePayload => ({
	name: LangContentToCreatePayload(model).filter(entry => Boolean(entry.content.trim())),
})

export const AddonCategoryToUpdatePayload = (
	updated: IAddonCategoryModel | null,
	model: IAddonCategoryForm,
): IAddonCategoryUpdatePayload => ({
	name: LangContentToUpdatePayload(model, updated).filter(entry => Boolean(entry.content.trim())),
})

// Wyciąga slug z pola addon_category zwracanego przez backend. Na zasobach CRM jest to obiekt
// (IMealAddonCategoryRef), ale ścieżka normalizacji dań publicznych (normalizePublicMealToDietMeal →
// buildMealKindFields) spłaszcza je wcześniej do samego slugu — stąd unia obiekt | string | null.
// Modele FE trzymają sam slug, dzięki czemu dotychczasowa logika wyświetlania, filtrów i pól warunkowych działa bez zmian.
export const getAddonCategorySlug = (value: IMealAddonCategoryRef | string | null): string | null => {
	if (value && typeof value === 'object') return value.slug

	return value ?? null
}

// Buduje mapę slug na id z listy kategorii pobranej z API; używana przy zapisie do zamiany wybranego sluga na numeryczny identyfikator.
export const buildAddonCategoryIdBySlug = (categories: IAddonCategoryModel[]): Record<string, number> =>
	categories.reduce<Record<string, number>>((map, category) => {
		map[category.slug] = category.id

		return map
	}, {})
